<template>
  <app-layout
    :state="state"
    header-type="landing"
  >
    <template #header>
      <icon-link
        :href="route('monitoring.index')"
        icon="arrow-thin-left-circle"
        class="icons-white"
      >
        Back to monitoring
      </icon-link>
      <h1>
        Project {{ project.ref }}
        <div class="flex items-baseline mt-1">
          <span
            v-if="project.stream"
            style="padding-block: .125rem"
            class="border rounded px-2 align-bottom text-xs inline-block leading-none mr-2"
            :style="getStreamColorsByKey(project.stream)"
          >
            {{ getStreamNameByKey(project.stream) }}
          </span>
          <small class="font-normal text-xs opacity-50 leading-none">{{ state.competition.title }}</small>
        </div>
      </h1>
    </template>

    <!-- Progress Report -->
    <progress-report
      class="col-span-full"
      :can-edit="canEdit"
      :monitoring="state.monitoring"
      :is-monitor="isMentor(monitorRole)"
      :is-msp="isMSP(monitorRole)"
    />
    <template v-if="isMSP(monitorRole)">
      <div class="container grid my-12">
        <!-- Claims -->
        <claims-revision-list
          :funding="$page.funding"
          :project="$page.project"
          :partners="partners"
          :claim-periods="claimPeriods"
          :forecast="forecast"
        />
      </div>
    </template>
  </app-layout>
</template>
<script>
import { userProjectMixin, userProjectNameLookupMixin } from '../mixins/userProject'
import { competitionStreamsMixin } from "../mixins/competitionStreams";
export default {
  name: 'MonitoringView',
  mixins: [userProjectMixin, userProjectNameLookupMixin, competitionStreamsMixin],
  data() {
    return {
      forecast: this.state.forecast,
    }
  },
  computed: {
    monitorRole() {
      return this.state.montior_role;
    },
    partners() {
      return this.state.partners ?? [];
    },
    claimPeriods() {
      return this.state.claim_periods ?? [];
    },
  },
	created() {
    window._project = this.project.uuid;
    document.title = `Project ${ this.state.project.ref } Overview :: ${document.title}`;
    this.forecast = Object.assign({}, this.state.forecast);
	},
}
</script>

<style lang="styl" scoped>
::v-deep
  .grid
    display grid;
    grid-template-columns repeat(12, 1fr);
    grid-gap 1.5rem;

  .sub-grid
    display grid;
    grid-template-columns subgrid;

  .col
    for col in (1..12)
      &-span-{col}
        grid-column span col / span col;

    &-span-full
      grid-column 1 / -1;
</style>
